export default {
  loginName: (state) => state.loginName,
  merchant: (state) => state.merchant,
  storeList: (state) => state.storeList,
  storeNo: (state) => state.storeNo,
  storeName: (state) => state.storeName
}
